// Adds a streamlined delivery choice to the existing Print Pack modal without
// changing the underlying Print Pack styling or print workflow.
const styles = `
.vc-pp-delivery{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:12px}.vc-pp-delivery button{border-radius:10px;padding:13px 10px;font-size:12px;font-weight:900;cursor:pointer}.vc-pp-esign{border:1px solid rgba(59,130,246,.35);background:linear-gradient(135deg,#2563eb,#0891b2);color:#fff}.vc-pp-esign-note{grid-column:1/-1;font-size:10px;line-height:1.45;color:rgba(255,255,255,.48)}
@media(max-width:700px){.vc-pp-delivery{grid-template-columns:1fr}.vc-pp-esign-note{grid-column:1}}
`;
const addStyles=()=>{if(document.getElementById('vc-pp-delivery-styles'))return;const s=document.createElement('style');s.id='vc-pp-delivery-styles';s.textContent=styles;document.head.appendChild(s)};

const enhance = () => {
  const modal=document.querySelector('.vc-pp-modal'); if(!modal || modal.dataset.deliveryEnhanced==='1') return;
  const print=modal.querySelector('.vc-pp-print'); if(!print) return;
  modal.dataset.deliveryEnhanced='1';
  print.textContent='🖨 Print / Download Pack';
  const wrap=document.createElement('div'); wrap.className='vc-pp-delivery';
  print.parentNode.insertBefore(wrap,print); wrap.appendChild(print);
  const esign=document.createElement('button'); esign.className='vc-pp-esign'; esign.textContent='✍ Send Pack for eSign'; wrap.appendChild(esign);
  const note=document.createElement('div'); note.className='vc-pp-esign-note'; note.textContent='eSign sends the completed Print Pack through the dealership’s configured certified e-signature provider and tracks sent, opened and completed status.'; wrap.appendChild(note);
  esign.onclick=()=>{
    window.dispatchEvent(new CustomEvent('vincentrix:send-print-pack-esign'));
    if(!window.__vcCertifiedEsignReady){
      window.alert('Print Pack eSign is ready for provider connection, but a certified e-signature provider has not been connected to this dealership yet. Print / Download remains available.');
    }
  };
};
addStyles();
new MutationObserver(enhance).observe(document.documentElement,{childList:true,subtree:true});
setTimeout(enhance,800);
export {};
